import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import moment from "moment";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";

function BusinessInformation() {
  const [isOpen, setIsOpen] = useState(false);
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const isMobile = useMediaQuery(768);

  return (
    <div
      className={`${style.accordion_item} ${expandDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isMobile ? (
          <CaretRight24 className={`${style.caret_icon} ${isOpen ? style.expended : ""}`} />
        ) : (
          <CaretDown24 />
        )}
        <h5>Business information</h5>
      </div>
      {isOpen && (
        <div className={`${style.accordion_body} ${isMobile && isOpen ? style.expanded : ""}`}>
          <>
            <HeadingWithLine
              text={"DBA Details"}
              className={style.heading_line}
            />
              <div className={style.accordion_body}>
                <div className={style.data_item}>
                  <p className={style.data_label}>MID</p>
                  <p className={style.data_value}>
                    {activeApp?.merchant_details?.mid || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Office</p>
                  <p className={style.data_value}>
                    {activeApp?.merchant_details?.office
                      || activeApp?.ems_office?.office_id
                      || activeApp?.user?.ems_office?.[0]?.label
                      || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Rep Code</p>
                  <p className={style.data_value}>
                    {activeApp?.merchant_details?.rep_code || activeApp?.user?.ems_rep_id || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Branch</p>
                  <p className={style.data_value}>
                    {activeApp?.merchant_details?.branch || activeApp?.user?.ems_branch || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>MCC Code</p>
                  <p className={style.data_value}>
                    {activeApp?.mcc_info?.mcc || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Status</p>
                  <p className={style.data_value}>
                    <StatusDot color="#37B450" /> Active
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Boarded</p>
                  <p className={style.data_value}>
                    {activeApp?.power_app_submission?.created_at
                      ? moment(activeApp?.power_app_submission?.created_at).format(
                          "MM/D/YYYY",
                        )
                      : "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Approved</p>
                  <p className={style.data_value}>
                    {activeApp?.power_app_submission?.created_at
                      ? moment(activeApp?.power_app_submission?.created_at).format(
                          "MM/D/YYYY",
                        )
                      : "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Closed</p>
                  <p className={style.data_value}>NA</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Last Statement</p>
                  <p className={style.data_value}>
                    {activeApp?.merchant_details?.last_statement
                      ? moment(activeApp.merchant_details.last_statement).format("MM/D/YYYY")
                      : "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Type of Ownership</p>
                  <p className={style.data_value}>
                    {activeApp?.field_ownership || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Legal Business Name</p>
                  <p className={style.data_value}>{activeApp?.field_legalname || "-"}</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>DBA Name</p>
                  <p className={style.data_value}>{activeApp?.field_dba || "-"}</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Tax ID / EIN</p>
                  <p className={style.data_value}>{activeApp?.field_ein || "-"}</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Premise Type</p>
                  <p className={style.data_value}>{activeApp?.premise_type || "-"}</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Period of Ownership</p>
                  <p
                    className={style.data_value}
                  >{`${activeApp?.field_ownershipyears || "-"} Years ${activeApp?.field_ownershipmonths || "-"} Months`}</p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Business Type</p>
                  <p className={style.data_value}>
                    {activeApp?.field_businesstype || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Tax exempt</p>
                  <p className={style.data_value}>
                    {activeApp?.powerappbusinessprofile?.tax_exempt || "NA"}
                  </p>
                </div>
              </div>

              <HeadingWithLine text={"Contacts"} className={style.heading_line} />
              <div className={style.accordion_body}>
                <div className={style.data_item}>
                  <p className={style.data_label}>Business Phone Number</p>
                  <p className={style.data_value}>
                    {activeApp?.field_businessphone || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Business Email</p>
                  <p className={style.data_value}>
                    {activeApp?.field_businessemail || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Business Website URL</p>
                  <p className={style.data_value}>
                    {activeApp?.field_website || "-"}
                  </p>
                </div>
              </div>

              <HeadingWithLine
                text={"DBA Address"}
                className={style.heading_line}
              />
              <div className={style.accordion_body}>
                <div className={style.data_item}>
                  <p className={style.data_label}>DBA City</p>
                  <p className={style.data_value}>
                    {activeApp?.field_dbacity || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>DBA Street</p>
                  <p className={style.data_value}>
                    {activeApp?.field_dbastreet || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>DBA State</p>
                  <p className={style.data_value}>
                    {activeApp?.field_dbastate || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>DBA Zip</p>
                  <p className={style.data_value}>
                    {activeApp?.field_dbazip || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Period of Location</p>
                  <p
                    className={style.data_value}
                  >{`${activeApp?.field_locationyears || "-"} Years ${activeApp?.field_locationmonths || "-"} Months`}</p>
                </div>
              </div>

              <HeadingWithLine
                text={"Legal Address"}
                className={style.heading_line}
              />
              <div className={style.accordion_body}>
                <div className={style.data_item}>
                  <p className={style.data_label}>Legal City</p>
                  <p className={style.data_value}>
                    {activeApp?.field_legalcity || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Legal Street</p>
                  <p className={style.data_value}>
                    {activeApp?.field_legalstreet || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Legal State</p>
                  <p className={style.data_value}>
                    {activeApp?.field_legalstate || "-"}
                  </p>
                </div>
                <div className={style.data_item}>
                  <p className={style.data_label}>Legal Zip</p>
                  <p className={style.data_value}>
                    {activeApp?.field_legalzip || "-"}
                  </p>
                </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default BusinessInformation;
